export enum BlockComparisonResult {
    Default = 1,
    Success = 2,
    Error = 3,
};